module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Regular.af8df21.woff";